<template>
  <el-collapse-transition>
    <el-card shadow="never" class="bid bid-item-view" :data-id="bid.id">
      <el-row>
        <el-col :span="1" class="img-block">
          <el-row class="arrow" />
          <el-row class="dots" />
          <el-row class="circle" />
        </el-col>
        <el-col :span="23" class="direction">
          <el-row>
            <el-row type="flex" justify="space-between" align="middle">
              <p>{{ loadLocationFilter(bid) }}</p>
              <p class="to ta-r">{{ getTypeCode }}</p>
            </el-row>
            <p class="to">{{ bid.load_point.split(',')[0] }}</p>
          </el-row>
          <el-row>
            <el-divider>
              <b>{{ bid.distance }} км, {{ bid.weight }} т.</b>
            </el-divider>
          </el-row>
          <el-row>
            <p class="from">{{ getStevedore() }}</p>
            <p class="to">{{ bid.unload_point.split(',')[1] }}</p>
          </el-row>
        </el-col>
      </el-row>
      <day-info :days="days" :choosed="!!day" />
      <el-row v-if="entries.length && !day" class="entries-block">
        <p class="entry-row">
          <b>Вы записались на погрузку:</b>
        </p>
        <entry-on-bid
          v-for="entry in entries"
          :key="`${entry.id}_${entry.index}`"
          :bid="bid"
          :entry="entry"
          v-on="$listeners"
        />
      </el-row>
      <el-row v-if="!day" :gutter="10" class="btn-block">
        <el-col v-if="getTypeView" :span="isAdminOrCeoRole ? 7 : 8">
          <el-button
            class="mob-btn map-btn qs"
            type="success"
            @click="$emit('set', bid, 'dialog_bid_points')"
          >
            На карте
          </el-button>
        </el-col>
        <el-col
          v-if="!isExp"
          :span="isAdminOrCeoRole ? 14 : 16"
          :class="`subscr-btn ${isAdminOrCeoRole ? 'ta-c' : 'ta-r'}`"
        >
          <el-button
            v-if="bid.future_days.length"
            :id="bid.id"
            class="mob-btn btn-application"
            type="success"
            @click="emitNext(bid)"
          >
            Записаться на погрузку
          </el-button>
        </el-col>
        <el-col
          v-if="isExpOrAdm && getTypeView"
          :span="isExp ? 16 : 3"
          class="ta-r"
        >
          <el-button
            v-if="bid.future_days.length"
            type="success"
            class="mob-btn arrow-btn"
            :icon="isProgress ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
            circle
            @click="isProgress = !isProgress"
          />
        </el-col>
      </el-row>
      <el-row class="bid-info">
        {{ getInfo() }}<br />
        <span v-if="bid.client_short_name && isAdminOrCeoRole">
          <b>Заказчик:</b> {{ bid.client_short_name }}<br />
        </span>
        <span><b>Комментарий:</b> {{ bid.comment }}</span
        ><br />
        <span
          v-if="
            bid.private_comment &&
            (!isDriverRole || (isDriverRole && isApproved()))
          "
        >
          <b>Телефон ответственного:</b> {{ bid.private_comment }}
        </span>
        <el-row v-if="isDriverRole && !isApproved()" type="flex" align="middle">
          Записаться по телефону:
          <el-link href="tel:+79384444420" type="primary" class="bid-el-link">
            +7 938 444-44-20
          </el-link>
        </el-row>
      </el-row>
      <el-collapse-transition>
        <el-row v-if="isProgress">
          <progres-bar-mobile
            v-for="fDay in bid.future_days"
            :key="fDay.id"
            :day="fDay"
            @gotoday="goToDay(fDay.index)"
          />
        </el-row>
      </el-collapse-transition>
    </el-card>
  </el-collapse-transition>
</template>

<script>
import { mapGetters } from 'vuex'
import { roundUp } from '@/helpers/functions'
import { typeCodes } from '@/datas/consts'
import DayInfo from './components/DayInfo'
import EntryOnBid from './components/EntryOnBid'
import ProgresBarMobile from './components/ProgresBarMobile'
import shippingMixin from '@/mixins/shippingMixin'

export default {
  name: 'BidMobile',
  components: { DayInfo, EntryOnBid, ProgresBarMobile },
  mixins: [shippingMixin],
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    freight: {
      type: String,
      default: '',
    },
    day: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isProgress: false,
    }
  },
  computed: {
    ...mapGetters({ getTypeView: 'bids/getTypeView' }),
    getTypeCode() {
      const type = typeCodes.find(t => t.label === this.bid.type_code)

      return type ? `Тип заявки: ${type.full || type.title}` : ''
    },
    days() {
      const days = this.day ? [this.day] : [...this.bid.future_days]
      const user = this.isExpOrAdm ? 'bidder' : 'driver'
      let type = this.bid.type_code === 'harvest' ? 'field' : 'storage'
      const field = `price_from_${type}_${user}`
      const field2 = `price_from_field_${user}`

      return days.reduce((d, x) => {
        const { [field]: price, [field2]: price2, load_date } = x
        const priceFormatted = roundUp(price, 1000)
        const priceText = `${priceFormatted} р/кг`
        const twoPrices = this.bid.type_code === 'harvest_or_delivery'
        let priceType = twoPrices ? ' Перевозка: ' : ''
        let priceText2 = twoPrices ? `${roundUp(price2, 1000)} р/кг` : ''
        let priceType2 = twoPrices ? ' Уборка: ' : ''

        if (d[priceFormatted]) {
          d[priceFormatted].dates.push(load_date)
        } else {
          d[priceFormatted] = {
            dates: [load_date],
            priceText,
            priceType,
            priceText2,
            priceType2,
          }
        }

        return d
      }, {})
    },
    entries() {
      return this.bid.entries || []
    },
    isExpOrAdm() {
      return this.isExp || this.isAdminOrCeoRole
    },
    isExp() {
      return this.userInfo.user_type === 2
    },
  },
  mounted() {
    this.$nextTick(() => this.$emit('ready'))
  },
  methods: {
    emitNext(bid) {
      this.$emit('next', bid)
    },
    goToDay(i) {
      this.$emit('load', true, i, this.bid)
    },
    isApproved() {
      return this.entries.find(e => Number(e.master_approve_status) === 1)
    },
    getStevedore() {
      const { organization } = this.bid
      const org =
        organization && organization.short_name
          ? ` на ${organization.short_name}`
          : ''

      return this.findStevedore(this.bid) + org
    },
    getInfo() {
      const { is_trawl, lifting_capacity, load_type_name } = this.bid
      let res = this.freight

      res += is_trawl ? ', грузим траллы' : ''

      res += load_type_name
        ? `, способ погрузки: ${
            load_type_name.charAt(0).toLowerCase() + load_type_name.slice(1)
          }`
        : ''

      if (lifting_capacity) {
        const text = this.getWeightText(lifting_capacity)

        res += `, весы на погрузке ${text}`
      }

      return res
    },
    getWeightText(count) {
      let text = ' тонн'
      const res10 = count % 10
      const res100 = count % 100

      if (res10 === 1 && res100 !== 11) {
        text = ' тонна'
      }
      if ([2, 3, 4].includes(res10) && ![12, 13, 14].includes(res100)) {
        text = ' тонны'
      }

      return count + text
    },
  },
}
</script>

<style lang="sass">
.btn-application
  color: #FFF
  background-color: #67C23A
  border: 1px solid #67C23A
</style>
